module.exports = __webpack_public_path__ + "static/media/html-5-logo.5a3b8a51.png";